import * as TYPES from './_store/types';


import { usePageStore } from "@/store";

export function asyncData(store) {
    
    let ps = [];
    ps.push(usePageStore(this.$pinia).getCompanyInfo());
    const {
        agentIds,
        autoSort = false,
        queryAll,
        showAllAgents,
        pageSize,
        pageNum,
        useSwiperApiParams
    } = this;
    ps.push(
        store[TYPES.FETCH_AGENTS]({
            queryAll,
            showAllAgents,
            agentIds,
            autoSort,
            pageSize,
            pageNum,
            useSwiperApiParams,
            initFlag: true
        })
    );
    return Promise.all(ps);
}
